// @import dependencies
import React, {Component} from 'react'
// @end

// @import components
import {AlleventsScreenLayout} from 'app_components/screens/landing/allevents'
// @end

// @ADD Component types
interface IAlleventsScreenProps {}
interface IAlleventsScreenState {}

class AlleventsScreen extends Component<IAlleventsScreenProps, IAlleventsScreenState> {

  render() {
    return(
      <AlleventsScreenLayout/>
    )
  }
}

export default AlleventsScreen
